import { Component, OnInit, OnDestroy } from '@angular/core';
import { trigger, style, transition, animate } from '@angular/animations';
import { AiAssistantService } from './ai-assistant.service';
import { AINotification } from './ai-assistant.types';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-ai-assistant',
  templateUrl: './ai-assistant.component.html',
  styleUrls: ['./ai-assistant.component.scss'],
  animations: [
    trigger('panelAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.9) translateY(20px)', transformOrigin: 'bottom right' }),
        animate('350ms cubic-bezier(0.34, 1.56, 0.64, 1)',
          style({ opacity: 1, transform: 'scale(1) translateY(0)' }))
      ]),
      transition(':leave', [
        animate('200ms cubic-bezier(0.4, 0.0, 0.6, 1)',
          style({ opacity: 0, transform: 'scale(0.9) translateY(20px)' }))
      ])
    ]),
    trigger('cardAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-16px)' }),
        animate('350ms cubic-bezier(0.22, 1, 0.36, 1)',
          style({ opacity: 1, transform: 'translateY(0)' }))
      ]),
      transition(':leave', [
        animate('250ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({ opacity: 0, transform: 'translateY(-8px)' }))
      ])
    ])
  ]
})
export class AiAssistantComponent implements OnInit, OnDestroy {
  messages: AINotification[] = [];
  hasUnread = false;
  isPanelVisible = false;

  private readonly destroy$ = new Subject<void>();

  constructor(private readonly aiAssistantService: AiAssistantService) {}

  ngOnInit(): void {
    this.aiAssistantService.messages$
      .pipe(takeUntil(this.destroy$))
      .subscribe(messages => this.messages = messages);

    this.aiAssistantService.hasUnread$
      .pipe(takeUntil(this.destroy$))
      .subscribe(hasUnread => this.hasUnread = hasUnread);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  trackById(_index: number, notif: AINotification): string {
    return notif.id;
  }

  togglePanel(): void {
    this.isPanelVisible = !this.isPanelVisible;
    if (this.isPanelVisible) {
      this.aiAssistantService.markAllRead();
    }
  }

  closePanel(): void {
    this.isPanelVisible = false;
  }
}
